// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"52758428","787":"05d1b904"}[chunkId] + ".chunk.js";
};